<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb :crumbs="[{ 'path': 'keys', 'name': 'Keys'}]" />
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-button
        type="primary"
        shape="round"
        @click="showDrawer"
        style="margin-top:10px;margin-bottom:30px;"
      >Create new key</a-button>
    </a-skeleton>
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-list
        :dataSource="allKeys"
        itemLayout="horizontal"
        :pagination="pagination"
        :grid="{ size: 'middle'}"
      >
        <a-list-item slot="renderItem" slot-scope="key" :rowKey="key.uuid">
          <a
            @click="$router.push({ name: 'keyEdit', params: { uuid: key.uuid }})"
            slot="actions"
            style="color: rgba(0, 0, 0, 0.45) !important;"
          >
            <a-icon type="form" style="padding:5px;"></a-icon>Edit
          </a>
          <div class="container">
            <b>KID:</b>
            <span class="key-id disabled">{{ key.uuid }}</span>
            <a-icon
              type="copy"
              style="fontSize:20px;cursor: pointer; padding:5px;"
              v-clipboard:copy="key.uuid"
              @click="success"
            />
          </div>
          <a-list-item-meta
            class="clickable"
            @click="$router.push({ name: 'keyEdit', params: { uuid: key.uuid } })"
            :description='key.key_algorithm+" - "+key.uuid'
          >
            <a slot="title">
              <b>
                {{ key.key_algorithm }}
                <a-tag color="green" v-if="key.is_default" style="margin-left: 5px;">Default</a-tag>
                <a-tag color="green" v-if="key.is_active" style="margin-left: 5px;">Active</a-tag>
                <a-tag color="gray" v-else style="margin-left: 5px;">Inctive</a-tag>
              </b>
            </a>
            <a-avatar
              slot="avatar"
              shape="square"
              :size="48"
              icon="key"
              style="background: #002e66;"
            />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-skeleton>
    <a-create-key v-if="!loading" />
  </div>
</template>

<script>
import ACreateKey from "@/components/Drawer/ACreateKey";

export default {
  data() {
    return {
      loading: true,
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 10
      }
    };
  },
  components: {
    ACreateKey
  },
  methods: {
    success() {
      this.$message.success("Client id copied.", 5);
    },
    showDrawer() {
      this.$store.dispatch("ui/showDrawer", {
        drawer_name: "create_key"
      });
    }
  },

  computed: {
    allKeys() {
      return this.$store.state.tenant.keys ? this.$store.state.tenant.keys : {};
    }
  },

  beforeCreate: async function() {
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "keys"
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="css">
.key-id {
  display: inline-block;
  width: 320px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  text-align: center;
  border-style: dashed;
  background: white;
  padding: 5px;
  margin-left: 5px;
}

.disabled {
  opacity: 0.7;
}
</style>
